import { render } from "./AdminCreateInvite.vue?vue&type=template&id=a62765bc"
import script from "./AdminCreateInvite.vue?vue&type=script&lang=js"
export * from "./AdminCreateInvite.vue?vue&type=script&lang=js"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__